import cx from "classnames";
import { SingleLineEditor } from "common/SingleLineEditor";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import appStyles from "../../App/appStyles.scss";
import styles from "./MastheadEditor.scss";

// Single-line, plaintext editor that wraps draft-js
export const MastheadEditor = ({ title, subtitle, onChange }) => {
  return (
    <div className={cx(styles.MastheadEditor, appStyles.base, appStyles.reportContainer)}>
      <div className={appStyles.title}>
        <SingleLineEditor
          defaultValue={title}
          placeholder={<T id="MastheadEditor.title" defaultMessage="Write a title for your report" />}
          textAlignment="center"
          onChange={(title) => onChange({ title })}
          plaintext
        />
      </div>
      <div className={appStyles.subtitle}>
        <SingleLineEditor
          defaultValue={subtitle}
          placeholder={<T id="MastheadEditor.subtitle" defaultMessage="Write a sub-title for your report" />}
          textAlignment="center"
          onChange={(subtitle) => onChange({ subtitle })}
          type="subtitle"
        />
      </div>
    </div>
  );
};
